import { emphasize } from '@material-ui/core/styles/colorManipulator';
import { fade } from '@material-ui/core/styles/colorManipulator';

export const styles = theme => ({
    boxAction: {
        display: 'flex',
        // justifyContent: 'space-between',
    },
    iconButton: {

    },
    icon: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer'
    },
    iconWrap: {
        fontSize: 40,
        float: 'right',
        cursor: 'pointer',
        padding: '4px'
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: fade('#9E9E9E', 0.15),
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        display: 'flex',
        // backgroundColor: '#eaeaea'
    },
    searchIcon: {
        width: theme.spacing(9),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
        width: '100%',
    },
    inputInput: {
        paddingTop: theme.spacing(1),
        paddingRight: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(10),
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            width: 120,
            '&:focus': {
                width: 200,
            },
        },
    },
    frameTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(3)
    }
})